import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Notifications_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Notifications: Notifications_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

